import React from 'react';
import { AlertTriangle, BadgeCheck, CheckCircle2 } from 'lucide-react';
import { Button } from '../../Button';
import { MobileHeader } from '../MobileHeader';
import { MobileInfoRow } from '../MobileInfoRow';
import { VerifyStepper } from '../VerifyStepper';
import { getDriver } from '../../../data/drivers';
import { cngs } from '../../../data/cngs';
import type { MobileNav } from '../../../types/mobile';
export function DriverDetailScreen({
  nav
}: {
  nav: MobileNav;
}) {
  const d = getDriver(nav.driverId) ?? getDriver('d1');
  const cng = cngs[0];
  if (!d) return null;
  const checks = ['ড্রাইভিং লাইসেন্স বৈধ', 'গাড়ির ফিটনেস বৈধ', 'ট্যাক্স টোকেন বৈধ', 'QR স্টিকার সক্রিয়'];
  return <div className="flex h-full flex-col bg-slate-50" data-id="element-808" data-mp="1qc0xchd3snnf">
      <MobileHeader title="চালকের বিস্তারিত" subtitle={d.qrId} onBack={nav.back} data-id="element-809" data-mp="1qenaqxmodxdk" />
      <VerifyStepper current={2} data-id="element-810" data-mp="24cldf5rmw5d8" />
      <div className="no-scrollbar flex-1 overflow-y-auto p-4" data-id="element-811" data-mp="1zd8u2uzz1gfe">
        <div className="overflow-hidden rounded-xl border border-border bg-white" data-id="element-812" data-mp="1zf214behy2nx">
          {d.photo && <img src={d.photo} alt={d.name} className="h-56 w-full object-cover object-top" data-id="element-813" data-mp="2mliyth3dms1d" />}
          <div className="flex items-center gap-2 bg-emerald-600 px-4 py-2.5 text-sm font-semibold text-white" data-id="element-814" data-mp="2rjkowlz7zrmc">
            <BadgeCheck className="h-5 w-5" data-id="element-815" data-mp="2wgubzuz4zr70" /> ✓ এই সিএনজির অনুমোদিত চালক
          </div>
          <div className="px-4 py-1" data-id="element-816" data-mp="31itfr5ysgq4h">
            <dl data-id="element-817" data-mp="35itt0na5iv9y">
              <MobileInfoRow label="চালকের নাম" value={d.name} data-id="element-818" data-mp="35jdeuf2xa3t9" />
              <MobileInfoRow label="ড্রাইভিং লাইসেন্স" value={d.license} mono data-id="element-819" data-mp="35gzje54bypl6" />
              <MobileInfoRow label="লাইসেন্সের ধরন" value={d.licenseType} data-id="element-820" data-mp="3ag3skvr98nbi" />
              <MobileInfoRow label="NID" value={d.nid} mono data-id="element-821" data-mp="3f9okc6298l29" />
              <MobileInfoRow label="মোবাইল" value={d.mobile} mono data-id="element-822" data-mp="3k7gktogytfi2" />
              <MobileInfoRow label="জন্মতারিখ" value={d.dob} data-id="element-823" data-mp="3k9syvqjlr5pu" />
              <MobileInfoRow label="লাইসেন্স ইস্যুর তারিখ" value={d.issueDate} data-id="element-824" data-mp="3p7uge71dqwz7" />
              <MobileInfoRow label="লাইসেন্স মেয়াদ" value={d.expiry} data-id="element-825" data-mp="3t7wlkq6bq8j8" />
              <MobileInfoRow label="বর্তমান অবস্থা" value={<span className="text-emerald-700" data-id="element-827" data-mp="1u4ppc1r686js">✓ সক্রিয়</span>} data-id="element-826" data-mp="1u3o2z14pfxmr" />
            </dl>
          </div>
        </div>
        <div className="mt-3 rounded-xl border border-border bg-white p-4" data-id="element-828" data-mp="1p5v12kafppsa">
          <p className="mb-2 text-xs font-semibold text-slate-500" data-id="element-829" data-mp="22w83y88gyear">স্বয়ংক্রিয় যাচাই — {cng.reg}</p>
          <ul className="space-y-1.5" data-id="element-830" data-mp="1y4zytoe69f3e">
            {checks.map(c => <li key={c} className="flex items-center gap-2 text-[13px] text-navy-900" data-id="element-831" data-mp="2ctw3dbh0s9z9">
                <CheckCircle2 className="h-4 w-4 text-emerald-600" data-id="element-832" data-mp="27v1k68f54jem" /> {c}
              </li>)}
          </ul>
        </div>
      </div>
      <div className="grid gap-2 border-t border-border bg-white p-3" data-id="element-833" data-mp="2ltj4dw5u7drs">
        <Button onClick={() => nav.go('success')} className="h-11 w-full bg-bdgreen-600 hover:bg-bdgreen-700" data-id="element-834" data-mp="2hsphn644s50h">
          <CheckCircle2 className="h-4 w-4" data-id="element-835" data-mp="rg1fo5tp4av6" /> যাচাই সম্পন্ন
        </Button>
        <Button variant="outline" onClick={() => {
        nav.setReportContext('valid');
        nav.go('report');
      }} className="h-10 w-full border-red-200 text-red-700 hover:bg-red-50 hover:text-red-700" data-id="element-836" data-mp="nfhfsuhqmt5c">
          <AlertTriangle className="h-4 w-4" data-id="element-837" data-mp="hc37d58bwuel" /> অনিয়ম রিপোর্ট করুন
        </Button>
      </div>
    </div>;
}